import { render, staticRenderFns } from "./BookingDirectRequest.vue?vue&type=template&id=3bec936c&scoped=true"
import script from "./BookingDirectRequest.vue?vue&type=script&lang=ts"
export * from "./BookingDirectRequest.vue?vue&type=script&lang=ts"
import style0 from "./BookingDirectRequest.vue?vue&type=style&index=0&id=3bec936c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec936c",
  null
  
)

export default component.exports